import './schedule-actions-init';
import './schedule-create-lessons/init';
import './schedule-move-lesson/init';
import './schedule-copy-lesson/init';
